import type { ChangeStoreConfirmationConfig } from '#types/config/components/dialog/changeStoreConfirmation'
import type { RecursivePartial } from '#types/utils'

export default {
  editLocationButtonVariant: 'secondary',
} satisfies RecursivePartial<ChangeStoreConfirmationConfig>
